
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Radar } from 'vue-chartjs'

@Component({
  extends: Radar
})
class RadarChart extends Vue {
  @Prop() readonly chartdata!: object
  @Prop() readonly options!: object

  private renderChart!: (chartData: object, options: object) => void

  private mounted() {
    this.renderChart(this.chartdata, this.options)
  }
}

export default RadarChart
